import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  TASK: {
    GET_HISTORY: (query) => ({ query }),
    API: {
      GET_HISTORY: apiResourceActionCreator('history')
    }
  }
})

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}/history${endpointQuery(query)}`, authToken, actions.task.api.getHistory);

function* getHistory(action) {
  const authToken = yield select(authTokenSelector);

  yield put(apiAction(authToken, action.payload.query));
}

const configuration = {
  name: 'getHistory',
  action: actions,
  sagas: getHistory,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingHistory: true
    }),
    success: (state, action) => ({
      ...state,
      history: action.payload.history,
      isFetchingHistory: false
    }),
    failed: (state, action) => ({
      ...state,
      isFetchingHistory: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/getHistory.js